import { render, staticRenderFns } from "./datetime.vue?vue&type=template&id=55d5640c&"
import script from "./datetime.vue?vue&type=script&lang=js&"
export * from "./datetime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports